export const GLOBAL_CONSTANT = {
  DEFAULT_INITIALIZER: 0, // for array
  DEFAULT_RELATIVE_DIAMETER: 0.2,
  MAC_ADDRESS_LENGTH: 12,
  MAC_ADDRESS_REGEX: /.{1,2}/g,
  ALPHANUMERIC_REGEX: /[^A-Z0-9]/g,
  NEGATIVE_ONE: -1,
  EMPTY_STRING: '',
  LANG_SLICE_NUMBER: 2,
  EVENT_SCROLL: 'scroll',
  WINDOW_SCROLL_MIN_HEIGHT: 100,
  SETTINGS: 'settings',
  SENSOR_CONNECT_V2: 'sensor-connect-v2',
  COLON: ':',
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  EIGHT: 8,
  NINE_HUNDRED_NINETY_NINE: 999,
  US_REGEX: '/us/',
  SERVICE_SCOPE: 'service_scope_',
  CONTENT: '_content',
  TEN: 10,
  TWENTY: 20,
  CONTENT_LATAM: '_content_latam',
  TAB_INDEX: 'tabIndex',
  BACK_BUTTON: 'backBtn',
  ID: 'id',
  COUNTRY_CODE_46: '46',
  STEAM_TRAP_EQUIPMENT_ID: 112,
  FLANGE_EQUIPMENT_ID: 109,
  ROTATING_EQUIPMENT_ID: 113,
  TIMEOUT_500_MS: 500,
  TIMEOUT_1000_MS: 1000,
  FILE_SIZE_LIMIT_20MB: 20971520,
  BI_METALLIC: 'Bi-metallic',
  APPLICATION_TYPE: {
    SMART_PIPE_EXTERNAL: 'smart-pipe_external',
    SMART_PIPE_COMPOSITE: 'smart-pipe_composite',
    SMART_FLANGE_SILICONE: 'smart-flange_silicone',
    SMART_FLANGE_COMPOSITE: 'smart-flange_composite',
    SMART_TANK: 'smart-tank',
  },
  MIN_MAX: 'minmax',
  MEASUREMENT_ID_INLET_TEMP: 1073,
  MEASUREMENT_ID_OUTLET_TEMP: 1074,
  INACTIVE_LEAKAGE_ID: 1078,
  INACTIVE_STEAM_TRAP_ID: 1079,
  INACTIVE_STEAM_TRAP_ANALYTICS_ID: 1080,
  DIRECT_C_LEAKAGE_ID: 1026,
  ZONE_COLOR_GREEN: '#d6f5cf',
  ZONE_COLOR_YELLOW: '#f8f1d4',
  ZONE_COLOR_RED: '#f8d3d3',
  ICON_COLOR_GREEN: '#548e54',
  ICON_COLOR_YELLOW: '#d5b742',
  ICON_COLOR_RED: '#e21321',
  ANIMATION_DURATION: 0,
  MAXIMUM_NAME_LENGTH: 36,
  CO2_CONVERSION_FACTOR: 0.16,
  DISPLAY_STEAM_TRAP_LOSS_AMOUNT: 1,
  DISPLAY_STEAM_TRAP_LOSS_MASS: 2,
  DISPLAY_STEAM_TRAP_LOSS_CO2: 3,
  STEAM_TRAP_STATUS_ID: 1068,
  STEAM_TRAP_STEAM_LOSS_AMOUNT_ID: 1069,
  STEAM_TRAP_STEAM_LOSS_MASS_ID: 1070,
  STEAM_TRAP_STEAM_LOSS_CO2_ID: 9999,
  STEAM_TRAP_STEAM_LOSS_MASS_WEEK_ID: 1083,
  STEAM_TRAP_STEAM_LOSS_MASS_MONTH_ID: 1085,
  STEAM_TRAP_STEAM_LOSS_MASS_3MONTH_ID: 1087,
  STEAM_TRAP_STEAM_LOSS_AMOUNT_WEEK_ID: 1084,
  STEAM_TRAP_STEAM_LOSS_AMOUNT_MONTH_ID: 1086,
  STEAM_TRAP_STEAM_LOSS_AMOUNT_3MONTH_ID: 1088,
  HISTORY_ITEM: {
    TYPE: {
      NOTIFICATION: 'notification',
      DOCUMENTATION: 'documentation',
    },
    DISPLAY: {
      DEFAULT: 'default',
      WORKING: 'working',
      CRITICAL: 'critical',
      WARNING: 'warning',
      INACTIVE: 'inactive',
    },
    DOCUMENTATION_TYPE: {
      REPAIR: 'repair',
      FIXED: 'fixed',
      FALSE_ALERT: 'false_alert',
      OTHER: 'other',
    },
  },
  ELLIPSIS: '...',
  NEEDS_IMMEDIATE_ATTENTION: 'needs immediate attention',
  UNACCEPTABLE: 'unacceptable',
};
